import MainSideBarMenu from '../../components/communication/sideBarMenus/mainSidebarMenu';
import SecondSideBarMenu from '../../components/communication/sideBarMenus/secondSidebarMenu';
import LocationsList from '../../components/communication/locationsList';
import PostDetails from '../../components/communication/postDetails';
import ConversationsList from '../../components/communication/conversationsList';
import {
  getLocationsAUserHasAccessTo,
  getSpecificLocation
} from '../../redux/slices/location/locationsList';
import { useDispatch, useSelector } from 'react-redux';
import Messages from '../../components/communication/messages';
import {
  getConversationDetailsFromBackend,
  getConversationsList,
  getCoversationDetails,
  getNotifications,
  resetCommunicationState,
  setLocation
} from '../../redux/slices/communication';
import { useEffect, useState } from 'react';
import { getUserDetails } from '../../redux/slices/user/userDetails';
import GeneralInformation from '../../components/communication/generalInfomation';
import { getCurrentLocationUUID } from '../../utils/communicationUtils';
import HelpModel from '../../components/communication/helpModel';
import ConnectInstagramModal from '../../components/communication/modals/ConnectInstagramModal';
import {
  toggleTemplateModal,
  triggerTemplateModalClose
} from '../../redux/slices/whatsappTemplate';
import ModalBody from '../../components/modals/modalBody';
import WhatsappTemplate from '../../components/whatsappTemplateBuilder';
export default function CommunicationPage() {
  const dispatch = useDispatch();
  const [locationUUID, setLocationUUID] = useState(null);
  const { openTemplateModal } = useSelector(
    (state) => state.WhatsappTemplateBuilder
  );
  useEffect(() => {
    // check if url has  location-slug

    if (getCurrentLocationUUID()) {
      setLocationUUID(getCurrentLocationUUID());
    }
    dispatch(getUserDetails());
    dispatch(getLocationsAUserHasAccessTo());
  }, []);
  useEffect(() => {
    if (getCurrentLocationUUID() != null) {
      // dispatch(getSpecificLocation(locationUUID));
      dispatch(setLocation({ uuid: getCurrentLocationUUID() }));
      // pull notifications
    }
    dispatch(getConversationsList());
    dispatch(getNotifications());
    // dispatch(getCoversationDetails());
    return () => {
      dispatch(resetCommunicationState());
    };
  }, []);

  return (
    <div
      className="p-5 d-flex flex-grow-1 overflow-hidden"
      style={{
        overflowX: 'hidden', // Disable horizontal scrolling
        overflowY: 'hidden', // Disable vertical scrolling
        maxHeight: locationUUID ? 'calc(100vh - 140px)' : 'calc(100vh - 80px)',
        minHeight: locationUUID ? 'calc(100vh - 140px)' : 'calc(100vh - 80px)'
      }}
    >
      <ConnectInstagramModal />
      <HelpModel />
      <MainSideBarMenu />
      {locationUUID == null && <LocationsList />}
      <div className="m-3" />
      <ConversationsList />
      <div className="m-3" />

      <Messages />
      <GeneralInformation />
      <PostDetails />
      <div className="m-3" />
      <SecondSideBarMenu />

      {openTemplateModal && (
        <ModalBody
          onClose={() => {
            dispatch(triggerTemplateModalClose());
          }}
        >
          <WhatsappTemplate locationUUID={locationUUID} />
        </ModalBody>
      )}
    </div>
  );
}
